import { Link } from "react-router-dom";
import { allCategories, allVideos } from "@/lib/video";

const highlights = [
  {
    icon: "ri-layout-grid-line",
    title: "分类清晰",
    desc: "影视剪辑、短视频、用户作品等六大板块，一眼找到想看的内容。",
    style: "bg-primary-100 text-primary-600",
  },
  {
    icon: "ri-filter-3-line",
    title: "多维筛选",
    desc: "支持按类型、上传时间、时长与热点标签筛选，快速锁定目标视频。",
    style: "bg-accent-100 text-accent-700",
  },
  {
    icon: "ri-sparkling-line",
    title: "相关推荐",
    desc: "每个视频详情页都附带相关推荐，浏览体验顺畅不断档。",
    style: "bg-secondary-100 text-secondary-700",
  },
];

const creators = new Set(allVideos.map((v) => v.author));
const stats = [
  { value: `${allVideos.length}`, label: "演示视频" },
  { value: `${allCategories.length}`, label: "内容分类" },
  { value: `${creators.size}`, label: "参与创作者" },
  { value: "100%", label: "免费浏览" },
];

export default function AboutSection() {
  return (
    <section className="mt-16 rounded-lg border border-background-200 bg-background-100 p-6 md:p-10">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="lg:col-span-1">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-information-line" />
            关于本站
          </span>
          <h2 className="mt-4 text-xl font-semibold text-foreground-950 md:text-2xl">
            简洁实用的视频聚合体验
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            逼特逼视频专注于把不同类型的视频内容聚在一起，用最直接的方式帮你发现、筛选和浏览感兴趣的作品。没有复杂的操作，打开即可开始探索。
          </p>
          <Link
            to="/contact"
            className="mt-5 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            反馈与建议
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="lg:col-span-2">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {highlights.map((item) => (
              <div
                key={item.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className={`flex h-10 w-10 items-center justify-center rounded-lg ${item.style}`}>
                  <i className={`${item.icon} text-xl`} />
                </span>
                <h3 className="mt-3 text-base font-medium text-foreground-900">{item.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-500">{item.desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((item) => (
              <div
                key={item.label}
                className="rounded-lg border border-background-200 bg-background-50 px-4 py-4 text-center"
              >
                <p className="font-heading text-2xl font-bold text-primary-600">{item.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}